/* eslint-disable no-console */
// Web-safe mock for react-native-simple-toast
// Provides basic toast functionality for web using console.log

const Toast = {
  show: (message, duration) => {
    // For web, we'll use console.log for development
    // In production, you could integrate with a web toast library
    console.log('Toast:', message);

    // Optional: Use browser alert for more visibility in development
    // if (__DEV__) {
    //   alert(message);
    // }

    // Return a mock promise for compatibility
    return Promise.resolve();
  },

  showWithGravity: (message, duration, gravity) => {
    console.log('Toast:', message, '(gravity:', gravity + ')');
    return Promise.resolve();
  },

  showWithGravityAndOffset: (message, duration, gravity, xOffset, yOffset) => {
    console.log(
      'Toast:',
      message,
      '(gravity:',
      gravity,
      'offset:',
      xOffset,
      yOffset + ')',
    );
    return Promise.resolve();
  },
};

export default Toast;
